import React from 'react'

import { CrownOne, Icon, TagComponent } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, string } from 'prop-types'

const premiumCrown = (
  <Icon
    svgComponent={CrownOne}
    className="subscription-tag__crown"
    color="extra-purple"
    notSpaced
  />
)

const CONFIG = {
  essentials: {
    color: 'primary',
    type: 'ghost',
    label: 'Essentials',
    leadIcon: null,
  },
  premium: {
    color: 'extra-purple',
    type: 'ghost',
    label: 'Premium',
    leadIcon: premiumCrown,
  },
}

// The chip encodes the catalog a model is IN, so it renders only for models actually
// opted in to a subscription. An opted-in model whose price left the eligible band
// (tierBand null) must stay blank rather than fall open.
function SubscriptionStatusTag({ itemId, subscriptionSubscribed = false, subscriptionTierBand = null }) {
  if (!subscriptionSubscribed) return null

  const config = CONFIG[subscriptionTierBand]
  if (!config) return null

  return (
    <TagComponent
      id={`subscription-tier-${subscriptionTierBand}-${itemId}`}
      color={config.color}
      type={config.type}
      leadIcon={config.leadIcon}
      small
    >
      {config.label}
    </TagComponent>
  )
}

SubscriptionStatusTag.propTypes = {
  itemId: string.isRequired,
  subscriptionSubscribed: bool,
  subscriptionTierBand: string,
}

export default SubscriptionStatusTag
